define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext", "./cpPackagesActions"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext, CPPackagesActions) {
    "use strict";
    var CPPackages = /** @class */ (function () {
        function CPPackages() {
            this.canExport = ko.observable(UserContext.hasAccess("Admin,CPPackages.Export"));
            this.userCanEditCPPackages = ko.observable(UserContext.hasAccess("Admin,CPPackages.Edit,CPPackages.Delete"));
            this.userCanDeleteCPPackages = ko.observable(UserContext.hasAccess("Admin,CPPackages.Delete"));
            this.filterByAny = ko.observable("");
        }
        CPPackages.prototype.init = function () {
            var self = this;
            $("#page-title").text("Customer Portal Packages");
            tools.ajaxGet({
                url: "/CPPackages/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.cpPackageLookupList = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.cpActions = new CPPackagesActions();
                    self.cpActions.afterSuccess = function () {
                        self.cpPackageTable.refresh();
                    };
                    self.initGrid(self.cpPackageLookupList.GridStructures.CPPackagesStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CPPackages.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblCPPackagesKendo";
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = "";
                    html += "<a class=\"btn btn-sm btn-yellow btn-edit\" href=\"/CPPackages/Details/".concat(dataItem.Id, "\"><i class=\"fa fa-edit \"></i></a>");
                    if (self.userCanDeleteCPPackages()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.cpPackageTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CPPackages/GetCPPackages",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#cppackages-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "CPPackages",
                    title: "CP Packages",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.cpPackageTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.cpPackageTable.getGridData().dataSource.read();
            });
            $("#" + gridId + " tbody").on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.cpActions.deletePackageConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        CPPackages.prototype.editCPPackage = function (id) {
            var self = this;
            self.cpActions.editPackage(id);
        };
        CPPackages.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("CPPackage");
                dataLogs.open("CPPackages logs");
                event.preventDefault();
            }
        };
        CPPackages.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.cpPackageTable.exportTo();
            }
        };
        return CPPackages;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/CPPackages/Index")) {
            log.log("Initialize CPPackages list");
            $(function () {
                (new CPPackages()).init();
            });
        }
    }, 0);
    return CPPackages;
});
//# sourceMappingURL=cpPackages.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customerPortalAdmin/cpPackages.js
// module id = 312
// module chunks = 2